import { useRef } from 'react'
import { useSetState } from 'ahooks'
import {Button, message, Switch, Upload} from 'antd'
import {
  SActionBtn,
  SDrawerOrModal,
  SFuncModalFormRef,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'

import { config } from './config.tsx'
import AddOrEdit from './addOrEdit'
import {
  generalDelete, generalImportBatchFile,
  generalUpdateById,
  getGeneralPage,
  getProductEnums, importFileDeleteDiscount,
} from '@/services/product.ts'
import { apiData2Table } from '@/utils/data.ts'
import { useNavigate } from 'react-router-dom'
import {DownloadOutlined, UploadOutlined} from "@ant-design/icons";
import {fileDownload} from "@/utils/download.ts";
import UrlConfig from "@/api/UrlConfigs.ts";

const GeneralManage = () => {
  const listRef:any = useRef()
  const editRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const navigate = useNavigate()

  const [state, setState]:any = useSetState({
    importLoading: false,
    exportLoading: false,
    loading: false,
    visible: false,
    record: {},
    isStandDrawer: false,
    standSearch: {},
  })

  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      getGeneralPage({
        params: { pageId: current, pageSize },
        data: { ...query, searchFlag: true },
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onChangeStatus = (enabled: boolean, record: Record<string, any>) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}通项，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return generalUpdateById({ data: { ...record, enabled } }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onAddOrEdit = (record = {}, isStand = false) => {
    setState({ visible: true, record: { ...record }, isStandDrawer: isStand })
  }
  // 跳转标配页面
  const clickToStandardPage = record => {
    console.log(record,'record');
    // 手动添加
    if (record.sonChooseType === 'GEN_STANDARD') {
      navigate(`/config/baseProduct/generalManage/standard-feature/${record.id}?itemName=${record.itemName}&&specialCode=${record.specialCode}`)
    } else {
      // 规则配置
      setState({ visible: true, record: { ...record }, isStandDrawer: true })
    }
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        return generalDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    editRef.current.onFinish?.()
  }

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const getStatusOptions = async () => {
    const statueEnum = await getProductEnums('com.shj.saas.plus.product.enums.StatueEnum')
    return Promise.resolve({ statueEnum })
  }

  const onExport = () => {

    setState({ exportLoading: true })
    fileDownload(UrlConfig.PlusProductWeb.GeneralTemplateBatchDownload)
        .then(() => setState({ exportLoading: false }))
        .catch(() => setState({ exportLoading: false }))
  }
  const onImport = (upload: any) => {
    setState({ importLoading: true })
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    return generalImportBatchFile(data)
        .then((res: any) => {
          listRef.current && listRef.current.reload()
          onSuccess && onSuccess()
          message.success(res.message || '导入成功')
        })
        .catch(onError)
        .finally(() => setState({ importLoading: false }))
  }

  const extensions = {
    request: { fetchList, getStatusOptions },
    events: { onAdd: () => onAddOrEdit() },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
            checked={v}
            onClick={checked => onChangeStatus(checked, record)}
          />
        )
      },
      importRender: () => {
        return (
            <Upload listType="text" customRequest={onImport} itemRender={() => null}>
              <Button
                  loading={state.importLoading}
                  disabled={state.importLoading}
                  icon={<UploadOutlined />}
              >
                批量导入
              </Button>
            </Upload>
        )
      },
      exportRender: () => {
        return (
              <Button
                  loading={state.exportLoading}
                  disabled={state.exportLoading}
                  onClick={onExport}
                  icon={<DownloadOutlined />}
              >
                下载导入模板
              </Button>
        )
      },
      actionRender(_: null, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
            <SActionBtn onClick={() => clickToStandardPage(record)}>标配</SActionBtn>
            <SActionBtn danger onClick={() => onDel(record.id)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
      <div>
        <SLowcodeList
          // tableType={'antd'}
          ref={listRef}
          searchMode={'group'}
          config={config}
          {...extensions}
        />
        <SDrawerOrModal
          width={500}
          onCancel={onCancel}
          onOk={onSubmit}
          open={state.visible}
          loading={state.loading}
          title={state.isStandDrawer ? '标配' : state.record.id ? '编辑' : '新增' + '通项'}
        >
          {state.visible && (
            <AddOrEdit
              editRef={editRef.current}
              onCancel={onCancel}
              isStand={state.isStandDrawer}
              fn={listRef.current?.reload}
              setLoading={loading => setState({ loading })}
              record={state.record}
            />
          )}
        </SDrawerOrModal>
      </div>
  )
}

export default GeneralManage
